import {now} from './lib/performance';
import {getHost} from './lib/env';

const DEFAULT_ENDPOINT = '';

let cacheKillerCounter = 0;

function addParam(url, key, value) {
  const separator = url.indexOf('?') === -1 ? '?' : '&';
  return `${url}${separator}${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
}

export function buildUrl({host, endpoint = DEFAULT_ENDPOINT}, params, context = {}) {
  host = host || getHost();
  endpoint = context.endpoint || endpoint;

  params._ = '' + new Date().getTime() + cacheKillerCounter++;
  params.ms = Math.round(now());

  const prefix = `//${host}/${endpoint}`;
  return Object.keys(params).reduce((url, key) => addParam(url, key, params[key]), prefix);
}

export function guid() {
  /*eslint-disable */
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    const r = Math.random() * 16 | 0;
    const v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16); 
  });
  /*eslint-enable */
}



// WEBPACK FOOTER //
// ./utils.js